<script>
import DeleteButton from "@components/general/DeleteButton.vue";
import DocsMixin from "./mixin";
import LabeledData from "./LabeledData.vue";

export default {
  name: "CustomerPreview",
  mixins: [DocsMixin],
  components: {
    DeleteButton,
    LabeledData
  },
  props: {
    customer: Object,
    formQNums: Object
  },
  data() {
    return {
      customerDefault: 'Once a customer is selected, their basic info will appear here.',
      deleting: false,
    }
  },
  computed: {
    customerInfo() {
      return {
        fullName: this.customer[this.formQNums.full_name] || '',
        driversLicense: this.customer[this.formQNums.drivers_license] || '',
        vMake: this.customer[this.formQNums.vehicle_make] || '',
        vModel: this.customer[this.formQNums.vehicle_model] || '',
        vYear: this.customer[this.formQNums.vehicle_year] || '',
        address: this.customer[this.formQNums.address] || '',
        city: this.customer[this.formQNums.city] || '',
        state: this.customer[this.formQNums.state] || '',
        zip: this.customer[this.formQNums.zip] || '',
        phone: this.customer[this.formQNums.phone] || '',
        email: this.customer[this.formQNums.email] || '',
        serviceType: this.customer[this.formQNums.service_type] || '',
        vin: this.customer[this.formQNums.vin_number] || '',
        dueDate: this.customer[this.formQNums.due_date] || ''
      }
    }
  },
  methods: {
    update() {
      this.$emit('update');
    },
  }
}
</script>

<template>
  <Panel header="Customer Info">
    <template v-if="customer">
      <div class="flex flex-col gap-4">
        <LabeledData label="Name" :content="customerInfo.fullName"/>
        <LabeledData
            label="Vehicle"
            :content="`${customerInfo.vYear} ${customerInfo.vMake} ${customerInfo.vModel}`"
        />
        <LabeledData label="VIN" :content="customerInfo.vin"
        />
        <div class="flex">
          <LabeledData label="DL#" :content="customerInfo.driversLicense"/>
          <LabeledData label="Phone" :content="customerInfo.phone"/>
        </div>
        <LabeledData label="Email" :content="customerInfo.email"/>
        <LabeledData
            label="Address"
            :content="`${customerInfo.address}, ${customerInfo.city}, ${customerInfo.state} ${customerInfo.zip}`"
        />
        <div class="flex">
          <LabeledData :content="customerInfo.serviceType" label="Type"/>
          <LabeledData :content="customerInfo.dueDate" label="Due Date"/>
        </div>
        <DeleteButton :delete-func="() => deleteCustomer(customer['entry_id'])" @update="update"/>
      </div>
    </template>
    <template v-else id="customer-preview" class="p-4">
      <span>
        {{ customerDefault }}
      </span>
    </template>
  </Panel>
</template>
